import * as React from "react";
import { Alert, Empty, notification, Radio, Spin, Tag } from "antd";
import { ModalPlm } from "src/components/ModalPlm";
import { ZObjState } from "src/types/ZObjState";
import { ZUid } from "src/types/zUid";
import { classNames } from "src/common/classNames";
import { loadAvailableStates } from "src/pages/EntityCardPage/apiEntityCard";
import { ZEntityAvailableState } from "src/pages/EntityCardPage/EntityPage.types";
import { onError } from "src/common/onError";
import styles from "./Mc2StatesChangeModal.module.less";

interface PropsMc2StatesChangeModal {
  open: boolean;
  close: () => void;
  mcObjectId: ZUid;
  currentStateId: ZUid;
  statesDict: Record<ZUid, ZObjState>;
  process: (dstStateId: ZUid) => Promise<void>;
}

export const Mc2StatesChangeModal: React.FC<PropsMc2StatesChangeModal> = (
  props,
) => {
  const { open, close, currentStateId, statesDict, mcObjectId, process } =
    props;
  const curStateName = statesDict[currentStateId]?.name;
  const hasError = currentStateId && !curStateName;
  const [statesList, setStatesList] = React.useState<ZEntityAvailableState[]>(
    [],
  );
  const [loading, setLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [dstStateId, setDstStateId] = React.useState<ZUid | null>(null);
  React.useEffect(() => {
    if (currentStateId) {
      setLoading(true);
      loadAvailableStates(mcObjectId, currentStateId, { translate: true })
        .finally(() => setLoading(false))
        .then((list) => setStatesList(list))
        .catch(onError);
    } else {
      setStatesList([]);
    }
  }, [currentStateId, mcObjectId]);
  React.useEffect(() => {
    if (open) {
      setDstStateId(null);
    }
  }, [open]);
  return (
    <ModalPlm
      title="Изменение состояния экземпляров"
      open={open}
      onCancel={close}
      okText="Изменить"
      okButtonProps={{
        disabled: !dstStateId,
        title: dstStateId ? undefined : "Не выбрано состояние для переключения",
        loading: saving,
      }}
      onOk={() => {
        if (dstStateId) {
          setSaving(true);
          process(dstStateId)
            .finally(() => setSaving(false))
            .then(() => {
              notification.success({ message: "Выполнена смена состояния" });
              close();
            })
            .catch(onError);
        }
      }}
    >
      <div className={styles.content}>
        <div className={styles.section}>
          <div className={styles.label}>Текущее состояние:</div>
          <div>
            {!hasError ? (
              <Tag color="gold">{curStateName}</Tag>
            ) : (
              <Alert type="error" message="Ошибка в данных" />
            )}
          </div>
        </div>

        <div className={classNames([styles.section, styles.mainSection])}>
          <div className={styles.label}>Изменить состояние:</div>
          <div className={styles.statesListBox}>
            <Spin spinning={loading}>
              {statesList.length === 0 && (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Нет состояний, доступных для переключения"
                />
              )}
              {statesList.length > 0 && (
                <Radio.Group
                  className={styles.statesList}
                  value={dstStateId}
                  onChange={(e) => setDstStateId(e.target.value)}
                  options={statesList.map(({ stateId, workflowName }) => ({
                    label: <Tag color="gold">{workflowName}</Tag>,
                    value: stateId,
                  }))}
                />
              )}
            </Spin>
          </div>
        </div>
      </div>
    </ModalPlm>
  );
};
